var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"help-btn",on:{"click":function($event){return _vm.$emit('open')}}},[_vm._v("Get Support")])}
var staticRenderFns = []

export { render, staticRenderFns }